<div class="chat-message-icon">
  @switch (icon) {
    @case (DataOrigin.NONE) {
      <svg noneOrigin styleClass="file-icon-medium"></svg>
    }
    @case (DataOrigin.FILES) {
      <svg filesOrigin styleClass="file-icon-medium"></svg>
    }
    @case (DataOrigin.REPOSITORY) {
      <svg repositoryOrigin styleClass="file-icon-medium"></svg>
    }
    @default {
      <svg repositoryOrigin styleClass="file-icon-medium"></svg>
    }
  }
</div>
